import { AccredibleCookiesBannerComponentModule } from '@accredible-frontend-v2/components/cookies-banner';
import { LayoutComponent } from '@accredible-frontend-v2/new-components/layouts';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SideContentComponent } from '@directory-of-directories/feature-list';
import { DoDBannerComponent } from '../banner/banner.component';
import { DoDFaqComponent } from '../faq/faq.component';
import { DoDFooterComponent } from '../footer/footer.component';
import { DoDHeaderComponent } from '../header/header.component';

@Component({
  standalone: true,
  selector: 'dod-root',
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
  imports: [
    RouterModule,
    AccredibleCookiesBannerComponentModule,
    LayoutComponent,
    DoDHeaderComponent,
    DoDBannerComponent,
    DoDFooterComponent,
    DoDFaqComponent,
    SideContentComponent,
  ],
})
export class ShellComponent {}
